// Typelizer digest bba017b33ba4c12130d8ac5e5e803293
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** GET /c/:company_id/ledger/review_queue/payment_groups */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/ledger/review_queue/payment_groups', {}, options),
    method: 'get',
  }),
}
